import { gql, useQuery, useMutation } from "@apollo/client";

// 노트 조회 쿼리
export const FETCH_NOTES = gql`
  query fetchNotes {
    fetchNotes {
      _id
      title
      description
      content
      parent
      children
      owner {
        _id
        name
      }
      users {
        _id
        name
      }
      viewers {
        _id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const FETCH_STARRED_NOTES = gql`
  query fetchStarredNotes {
    fetchStarredNotes {
      _id
    }
  }
`;

// 노트 생성 뮤테이션
export const CREATE_NOTE = gql`
  mutation createNote(
    $title: String!
    $content: String
    $description: String
    $parent: ID
  ) {
    createNote(
      title: $title
      content: $content
      description: $description
      parentId: $parent
    ) {
      _id
      title
      description
      content
      parent
      children
      owner {
        _id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

// 노트 수정 뮤테이션
export const UPDATE_NOTE = gql`
  mutation updateNote(
    $noteId: ID!
    $title: String
    $content: String
    $description: String
    $children: [ID!]
  ) {
    updateNote(
      noteId: $noteId
      title: $title
      content: $content
      description: $description
      childrenIds: $children
    ) {
      _id
      title
      description
      content
      parent
      children
      owner {
        _id
        name
      }
      users {
        _id
        name
      }
      viewers {
        _id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CHILDREN = gql`
  mutation updateChildren($noteId: ID!, $children: [ID!]!) {
    updateChildren(noteId: $noteId, childrenIds: $children) {
      _id
      title
      description
      content
      parent
      children
      updatedAt
    }
  }
`;

// 노트 삭제 뮤테이션
export const DELETE_NOTE = gql`
  mutation deleteNote($noteId: ID!) {
    deleteNote(noteId: $noteId) {
      _id
    }
  }
`;

// 노트 즐겨찾기 토글
export const TOGGLE_STAR_NOTE = gql`
  mutation toggleStarNote($noteId: ID!) {
    toggleStarNote(noteId: $noteId) {
      _id
      starred {
        _id
      }
    }
  }
`;

export const useClientNotes = () => {
  const {
    data: notesData,
    loading: notesLoading,
    error: notesError,
    refetch: refetchNotes,
  } = useQuery(FETCH_NOTES);
  const {
    data: starredNotesData,
    loading: starredNotesLoading,
    //@ts-ignore
    error: starredNotesError,
    refetch: refetchStarredNotes,
  } = useQuery(FETCH_STARRED_NOTES);

  const [createNoteMutation] = useMutation(CREATE_NOTE, {
    onCompleted: () => {
      // refetchNotes();
    },
  });

  const [updateNoteMutation] = useMutation(UPDATE_NOTE, {
    onCompleted: () => {
      // refetchNotes();
    },
  });

  const [updateChildrenMutation] = useMutation(UPDATE_CHILDREN, {
    onCompleted: () => {
      // refetchNotes();
    },
  });

  const [deleteNoteMutation] = useMutation(DELETE_NOTE, {
    onCompleted: () => {
      // refetchNotes();
    },
  });

  const [toggleStarMutation] = useMutation(TOGGLE_STAR_NOTE, {
    onCompleted: () => {
      refetchStarredNotes();
    },
  });

  const createNote = async (input: {
    title: string;
    content?: string;
    description?: string;
    parentId?: string;
  }) => {
    try {
      const { data } = await createNoteMutation({
        variables: input,
      });
      return data.createNote;
    } catch (error) {
      console.error("Failed to create note:", error);
      throw error;
    }
  };

  const updateNote = async (
    noteId: string,
    input: {
      title?: string;
      content?: string;
      description?: string;
      childrenIds?: string[];
    },
  ) => {
    try {
      const { data } = await updateNoteMutation({
        variables: {
          noteId,
          ...input,
        },
      });
      return data.updateNote;
    } catch (error) {
      console.error("Failed to update note:", error);
      throw error;
    }
  };

  const updateChildren = async (noteId: string, childrenIds: string[]) => {
    try {
      const { data } = await updateChildrenMutation({
        variables: {
          noteId,
          childrenIds,
        },
      });
      return data.updateChildren;
    } catch (error) {
      console.error("Failed to update note:", error);
      throw error;
    }
  };

  const deleteNote = async (noteId: string) => {
    try {
      const { data } = await deleteNoteMutation({
        variables: { noteId },
      });
      return data.deleteNote;
    } catch (error) {
      console.error("Failed to delete note:", error);
      throw error;
    }
  };

  const toggleStarNote = async (noteId: string) => {
    try {
      const { data } = await toggleStarMutation({
        variables: { noteId },
      });
      return data.toggleStarNote;
    } catch (error) {
      console.error("Failed to toggle star:", error);
      throw error;
    }
  };

  const refetch = async () => {
    await refetchNotes();
    await refetchStarredNotes();
  };

  return {
    notes: notesData?.fetchNotes || [],
    starredNotes: starredNotesData?.fetchStarredNotes || [],
    loading: notesLoading || starredNotesLoading,
    error: notesError,
    createNote,
    updateNote,
    deleteNote,
    updateChildren,
    toggleStarNote,
    refetch: refetch,
  };
};

export default useClientNotes;
